export const defaultNumberPerPage = 10
export const numberPerPageOptions = [
  { value: 10, text: "10" },
  { value: 15, text: "15" },
  { value: 20, text: "20" },
  { value: 30, text: "30" },
  { value: 50, text: "50" }
]
